import { useState } from 'react'
import Layout, { Card, Empty } from '@/components/Layout'
import { router } from '@inertiajs/react'
import { useCanWrite } from '@/lib/access'
import type { RewardFull } from '@/types'

export default function Index({ rewards, balance }: { rewards: RewardFull[]; balance: number }) {
  const canWrite = useCanWrite()
  const [title, setTitle] = useState('')
  const [cost, setCost] = useState('')
  const [stock, setStock] = useState('')

  const add = () => {
    if (!title.trim() || !Number(cost)) return
    router.post('/rewards', { title, cost, stock }, { onSuccess: () => { setTitle(''); setCost(''); setStock('') } })
  }

  return (
    <Layout>
      <Card title="🛍️ 奖励商店" extra={<span className="text-[#707d90] text-[13px]">余额 {balance} 分</span>}>
        {canWrite && (
          <div className="flex gap-2.5 flex-wrap items-center mb-3.5">
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="奖励，例如：买一双新跑鞋" className="flex-1 min-w-[130px] border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <input type="number" value={cost} onChange={(e) => setCost(e.target.value)} placeholder="积分价" min={1} className="w-[100px] border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <input type="number" value={stock} onChange={(e) => setStock(e.target.value)} placeholder="次数(空=不限)" min={1} className="w-[130px] border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <button onClick={add} className="bg-[#5b7cfa] text-white font-semibold px-4 py-2 rounded-[10px]">添加奖励</button>
          </div>
        )}
        {rewards.length ? rewards.map((r) => {
          const afford = balance >= r.cost
          return (
            <div key={r.id} className="flex items-center gap-2.5 py-2.5 border-t border-dashed border-[#e7ebf2] first:border-t-0">
              <span className="flex-1">{r.title} {r.stock != null && <span className="text-[#707d90] text-[13px]">· 剩 {r.stock} 次</span>}</span>
              <span className="font-bold text-[#f5a623] whitespace-nowrap">{r.cost} 分</span>
              {canWrite && <button disabled={!afford || r.out_of_stock} onClick={() => router.post(`/rewards/${r.id}/redeem`)} className="bg-[#5b7cfa] text-white font-semibold text-[13px] px-3 py-1.5 rounded-[10px] disabled:opacity-40">{r.out_of_stock ? '已兑完' : afford ? '兑换' : '积分不足'}</button>}
              {canWrite && <button onClick={() => router.delete(`/rewards/${r.id}`)} className="text-[#707d90] hover:text-[#ef5350] text-base px-1.5">✕</button>}
            </div>
          )
        }) : <Empty>奖励商店是空的，添加几个犒赏自己～</Empty>}
      </Card>
    </Layout>
  )
}
